function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M408 32v16h52.688l-18.344 18.344 11.312 11.312L491.312 40 453.656 2.344l-11.312 11.312L460.688 32zM45.656 418.344l-11.312 11.312L52.688 448H0v16h52.688l-18.344 18.344 11.312 11.312L83.312 456zM240 416h48v-16h-32v-80h-16zm0-176h16v16h-16z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.584 416H176v-96h-16v80H72.776C36.136 357.808 16 303.968 16 248c0-25.128 4.072-49.32 11.496-72H96v-16H33.384C56.944 102.752 102.752 56.944 160 33.384V96h16V27.496A231.036 231.036 0 0 1 248 16h160V0H248C111.256 0 0 111.248 0 248c0 61.104 22.448 119.816 63.2 165.336L65.584 416z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M480 160.376V160h-.136A247.862 247.862 0 0 0 432.8 82.664L430.416 80H240v16h80v64H160v80H80v96h16v-80h80v-80h160V96h87.224a231.786 231.786 0 0 1 39.4 64H400v80H272v16h48v80h96v-16h-80v-64h80v-80h52.544A231.731 231.731 0 0 1 480 248c0 96.784-59.592 179.88-144 214.616V400h-32v16h16v52.504A231.036 231.036 0 0 1 248 480H80v16h168c136.744 0 248-111.248 248-248 0-30.232-5.512-59.872-16-87.624z"
});

var SvgIconUntrace = function SvgIconUntrace(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 496 496",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconUntrace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-untrace.1c85f246.svg";
export { ForwardRef as ReactComponent };